module.exports = __webpack_public_path__ + "img/H-63-ER-1200-GA.9397ba3e.png";